import React, { useState, useEffect } from 'react'
import PopupBG from '../../assets/svg/popup-bg.svg';
import Modal from '../Modal'
import Button from '../Button';
import commonService from '../../services/commonService';
import { usePost, useGet } from "../../libs/service/api";
import { isEmpty, checkSpecialCharacter, checkChar, checkDigit } from '../../libs/validation/validators';
// import authenticator from "../../services/authenticateService";
import cookie from "../../libs/cookie/client";
const CreatePassswordModal = props => {
    const { toast, snackbar } = require('tailwind-toast')
    const userData = commonService.getUserData();
    const [password, setPassword] = useState("");
    const [confirmpassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("")

    // var handleBlur = (e) => {
    //     setError("");
    //     setPassword(e.target.value)
    // }
    // var handleChange = (e) => {
    //     setError("");
    //     setPassword(e.target.value)
    // }

    const ChangePasswordClick = () => {
        if (isEmpty(password)) {
            setError("Password cannot be left blank");
        } else if (!isEmpty(password)) {
            if (password.length < 8 || !checkSpecialCharacter(password) || !checkChar(password) || !checkDigit(password)) {
                setError("Your Password needs to have at least 8 characters, 1 special character and 1 number");
            } else if(password !== confirmpassword) {
                setError("New Password and Confirm Password do not match.");
            }else{
                SavePassword()
            }
        }
    }
    const CallLogin = () => {
        usePost('/api/auth/postlogin', { username: cookie.getItem("email"), password: password }).then(res => {

            cookie.setItem('authorizationKey', res.data);
            cookie.setItem('passwordexist', 1);
            cookie.setItem('username', res.name);
            cookie.setItem('userid', res.userid);
            toast().success('', 'Password Set Sucessfully').with({
                shape: 'square',
                duration: 2000,
                speed: 200,
                positionX: 'end',
                positionY: 'top',
                color: 'text-white bg-primary border-primary-dark border rounded-lg',
                fontColor: 'white',
                fontTone: 0
            }).show()
            if (props.onCustomDashboardClick() !== undefined) {
                props.onCustomDashboardClick()
            }
            props.closeTrigger()
        });

    }
    const SavePassword = () => {
        usePost('/commonapi/savepassword',
            [{
                "key": "usersid",
                "value": cookie.getItem("userid")
            },
            {
                "key": "password",
                "value": password
            }]
        ).then(res => {
            if (!res.ErrorState) {
                CallLogin()
            }
        });
    }
    return (
        <Modal isOpen={props.isOpen} closeTrigger={() => props.closeTrigger()}>
            <div className="px-4 flex items-center pb-2" style={{ minHeight: 296 }} >
                <img src={PopupBG} className="absolute right-0 top-0 h-full -mr-px" alt="" />
                <div className="w-full">
                    <p className='font-bold'>Please create account to access this option.<br /></p>
                    <p>Setup your <span className="text-green-600 font-bold">Password</span> here.</p>

                    <div className="w-1/2 mt-4 flex whitespace-nowrap relative flex-col">
                        <label>Password</label>
                        <input
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            onChange={(e) => { setError("");
                            setPassword(e.target.value)}}
                            onBlur={(e) => { setError("");
                            setPassword(e.target.value)}}
                            type="password"
                            value={password}
                            name="password"
                            placeholder="*******" className="mr-2 border-b-2 italic p-2 border-black text-sm focus:outline-none  w-full" />
                        <span class="text-xs absolute top-full text-red-700">{error}</span>
                    </div>

                    <div className="w-1/2 mt-4 mb-6 flex whitespace-nowrap relative flex-col">
                        <label>Confirm Password</label>
                        <input
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            onChange={(e) => { setError("");
                            setConfirmPassword(e.target.value)}}
                            onBlur={(e) => { setError("");
                            setConfirmPassword(e.target.value)}}
                            type="password"
                            value={confirmpassword}
                            name="confirmpassword"
                            placeholder="*******" className="mr-2 border-b-2 italic p-2 border-black text-sm focus:outline-none  w-full" />
                        <span class="text-xs absolute top-full text-red-700">{error}</span>
                    </div>
                    <Button btnStyle="primary-outline m-4 " text="Create account" onClick={ChangePasswordClick} />
                </div>
            </div>
        </Modal>
    )
}


export default CreatePassswordModal
